<template>
  <div class="profile">
    <div v-on-click-away="hideDropdown" class="profile__header" @click="toggleDropdown">
      <div class="profile__header-info">
        <div class="profile__header-name" :title="userFullName.length > 10 ? userFullName : ''">
          {{ userFullName }}
        </div>

        <div class="profile__header-company" :title="userCompanyName.length > 10 ? userCompanyName : ''">
          {{ userCompanyName }}
        </div>
      </div>

      <img :src="currentUser.logo || '/static/icons/icon_man.png'" class="profile__avatar" />
    </div>

    <transition name="slide-fade">
      <div v-if="showDropdownMenu" class="profile__dropdown">
        <keep-alive>
          <sportmaster-user-info v-if="getProcessName === PROCESS_NAMES.SPORTMASTER" :current-user="currentUser" />
        </keep-alive>

        <div class="profile__dropdown-title mt0">{{ $tr('profile.group.settingsTitle') }}</div>
        <ul class="profile__dropdown-list">
          <!-- TODO: Commented onboarding -->
          <!-- <li class="dropdown_item">
            <a
            v-if="isDomainRu"
            class="dropdown-flex dropdown-link"
            @click.prevent="showOnboarding"
            ></a>
            <a v-if="isDomainRu" class="dropdown-flex dropdown-link">
            <div class="dropdown_image">
            <svg class="cv-row-icon">
            <use xlink:href="/static/icons/icons-header.svg#onboarding" />
            </svg>
            </div>
            <span>{{ $tr('header.profile.onboarding') }}</span>
            </a>
            </li> -->
          <router-link tag="li" to="/profile" class="profile__dropdown-item">
            <i class="icon-profile"></i>
            <span>{{ $tr('profile.title') }}</span>
          </router-link>

          <router-link v-if="isCompanyAdmin" tag="li" :to="{ name: 'settings-company' }" class="profile__dropdown-item">
            <i class="icon-settings"></i>
            <span>{{ $tr('profile.group.settingsTitle') }}</span>
          </router-link>
        </ul>

        <div class="profile__dropdown-title">{{ $tr('common.support') }}</div>

        <li v-if="getProcessName === PROCESS_NAMES.ALROSA" class="profile__dropdown-item" @click="openAlrosaHelpdesk">
          <i class="icon-helpdesk"></i>
          <span>{{ $tr('vacancy.preferences.footerInfo.first.title') }}</span>
        </li>

        <li v-if="isDomainRu" class="profile__dropdown-item">
          <i class="icon-manual-book"></i>
          <a href="https://docs.google.com/document/d/1FAyIDV6iCS2_3Aj5LvXwC0njgfilqQ_vKxalYtuNwms" target="_blank">
            {{ $tr('common.vcv-manual') }}
          </a>
        </li>

        <personal-manager :manager="personalManager" />

        <rates-info />

        <div class="item-rates-button">
          <vbutton
            v-if="isCompanyAdmin"
            class="button-rates"
            label="rates.chooseTariff"
            :loading="loading"
            block
            @click="is_rates_modal_visible = true"
          />
          <!-- @click="$router.push({ name: 'billing-tariffs' })" -->
        </div>

        <router-link tag="li" to="/logout" class="profile__signout" @click.prevent="authAdmin">
          <i class="icon-signout"></i>
          <span>{{ $tr('login.logout') }}</span>
        </router-link>
      </div>
    </transition>

    <price-info :is_rates_modal_visible="is_rates_modal_visible" @toggle_rates_modal="toggleRatesModal" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { isDomainRu } from '@/_helpers/utils.js';
import BrowserStore from 'store';
import { directive as VueClickAway } from 'vue-clickaway';
import PersonalManager from './PersonalManager.vue';
import RatesInfo from './RatesInfo.vue';
// import RatesManagement from './RatesManagement.vue';
import PriceInfo from './PriceInfo.vue';
import PROCESS_NAMES from '@/process/names';

// process
import SportmasterUserInfo from '@/process/sportmaster/components/header/SportmasterUserInfo';

export default {
  name: 'ProfileInfoDefault',

  components: {
    PersonalManager,
    RatesInfo,
    // RatesManagement,
    PriceInfo,
    SportmasterUserInfo
  },

  directives: {
    onClickAway: VueClickAway
  },

  data() {
    return {
      PROCESS_NAMES,
      showDropdownMenu: false,
      is_rates_modal_visible: false,
      is_second_step: false,
      loading: false,
      loadingLinks: false,
      response_id: null,
      vacancy_id: null
    };
  },

  computed: {
    ...mapGetters('locale', { locale: 'current', is_japan_locale: 'is_japan_locale' }),

    ...mapGetters('process', ['getProcessName']),

    ...mapGetters('company', { companyOne: 'one' }),

    ...mapState('company_new', ['rates']),

    ...mapGetters('user', { currentUser: 'current', isCompanyAdmin: 'isCompanyAdmin' }),

    isDomainRu,

    userFullName() {
      if (!this.currentUser) {
        return '';
      }

      return !this.is_japan_locale ? this.currentUser.full_name : this.currentUser.full_name_reverse;
    },

    company() {
      return this.currentUser ? this.currentUser.company : null;
    },

    companyLanguage() {
      if (!this.companyOne) {
        return null;
      }
      if (this.companyOne.language && this.companyOne.language.code) {
        return this.companyOne.language.code.toLowerCase();
      }
      if (this.companyOne.country && this.companyOne.country.code) {
        return this.companyOne.country.code.toLowerCase();
      }
      return 'en';
    },

    company_id() {
      if (!this.company) {
        return null;
      }

      return this.company.id;
    },

    userCompanyName() {
      const userCompany = this.currentUser ? this.currentUser.company : null;

      return userCompany ? userCompany.name : '';
    },

    helpExists() {
      return !!this.$store.state.managers.data;
    },

    personalManager() {
      const state = this.$store.state.managers;
      let defaultEmail = '';

      if (this.companyLanguage === 'ru') {
        defaultEmail = 'clientsupport@vcv.ru';
      } else if (this.companyLanguage === 'ja') {
        defaultEmail = 'jpsupport@vcv.co.jp';
      } else {
        defaultEmail = 'hey@vcv.ai';
      }

      return state && state.data
        ? state.data
        : {
            email: defaultEmail,
            isManagerDefault: true
          };
    },

    has_rates() {
      if (!this.rates) {
        return false;
      }
      return !this.rates.is_free;
    }
  },

  beforeMount() {
    this.$store.dispatch('managers/fetchPersonalManagerInfo');

    if (!this.currentUser || !this.currentUser.id) {
      this.fetchUser();
    }
    // TODO: Commented onboarding
    // this.getOnboardingLinks();
  },

  methods: {
    toggleDropdown() {
      this.showDropdownMenu = !this.showDropdownMenu;
    },

    hideDropdown() {
      this.showDropdownMenu = false;
    },

    fetchUser() {
      const token = BrowserStore.get('access_token');

      this.$store.dispatch('user/userInfoRequest', token.user.email);
    },

    authAdmin() {
      if (window.localStorage.admin_token) {
        window.localStorage.removeItem('admin_token');
      }
      this.$router.push({ path: '/logout' });
    },

    toggleRatesModal(val) {
      this.is_rates_modal_visible = val;
    },

    openAlrosaHelpdesk() {
      window.open('https://helpdesk.alrosa.ru/portal/sc?item=166503844708980519', '_blank').focus();
    }

    // TODO: Commented onboarding
    // getOnboardingLinks() {
    //   this.loadingLinks = true;
    //   axios.get('/1.0/company-onboarding/demo-ids')
    //     .then((response) => {
    //       const data = response.data.data[0];
    //       this.response_id = data.response_id;
    //       this.vacancy_id = data.vacancy_id;
    //       window.experrtoProps = {
    //         responseId: this.response_id,
    //         vacancyId: this.vacancy_id,
    //       };
    //       this.loadingLinks = false;
    //     })
    //     .catch(() => {
    //       this.loadingLinks = false;
    //     });
    // },

    // showOnboarding() {
    //   if (window.Experrto && window.Experrto.show) {
    //     window.Experrto.show(3478);
    //   } else {
    //     Security.loadOnboarding(Experrto => {
    //       setTimeout(() => {
    //         Experrto.show(3478);
    //       }, 3000);
    //     });
    //   }
    // }
  }
};
</script>

<style lang="scss">
@import '@/styles/fonts.scss';

.profile {
  height: 100%;
  width: 230px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;

  @media screen and (max-width: 1250px) {
    width: 210px;
  }

  &__avatar {
    width: 64px;
    height: 64px;
    flex: 0 0 64px;
  }

  &__header {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    cursor: pointer;
  }

  &__header-info {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    padding: 3px 9px 3px 10px;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__header-name {
    @include mixin-text-header;
    text-align: right;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 3px;
  }

  &__header-company {
    @include mixin-text-header;
    font-size: 12px;
    color: $grey;
    text-align: right;
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__dropdown {
    width: 100%;
    display: block;
    position: absolute;
    background: #fff;
    top: 65px;
    right: 0;
    list-style-type: none;
    box-sizing: border-box;
    padding: 20px;
    border: 0;
    max-height: calc(100vh - 65px);
    overflow: auto;
    box-shadow: $box-shadow;
  }

  &__dropdown-subtitle {
    @include mixin-text-tag;
  }

  &__dropdown-title {
    @include mixin-text-header;
    margin-bottom: 15px;
    margin-top: 15px;

    &.mt0 {
      margin-top: 0;
    }
  }

  &__dropdown-item {
    @include mixin-text-main;
    color: $main-dark;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: nowrap;
    cursor: pointer;
    transition: color 0.3s;

    a {
      display: flex;
      overflow: hidden;
      color: $main-dark;
      transition: color 0.3s;
    }

    i {
      margin-right: 10px;
      color: $main-dark;
      font-size: 16px;
      margin-top: 1px;
      transition: color 0.3s;
    }

    span {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 100%;
      color: $main-dark;
      transition: color 0.3s;
    }

    &:hover {
      color: $green-hover;
      transition: color 0.3s;

      i,
      span,
      a {
        color: $green-hover;
        transition: color 0.3s;
      }
    }

    &.active,
    &.router-link-exact-active {
      i,
      span {
        color: $green;
      }
    }
  }

  &__signout {
    @include mixin-text-main;
    color: $grey;
    text-align: center;
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color 0.3s;

    i {
      color: $grey;
      margin-right: 10px;
      transition: color 0.3s;
    }

    &:hover {
      color: $main-dark;
      transition: color 0.3s;

      i {
        color: $main-dark;
        transition: color 0.3s;
      }
    }
  }

  &__divider {
    height: 1px;
    width: 100%;
    background: $grey-light;
    margin: 20px auto;
  }
}

.slide-fade-enter,
.slide-fade-leave-to {
  transition: all 0.3s ease;
  transform: translateY(5px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease-in-out;
}
</style>
